module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6mUYZ"))).then(() => parcelRequire('cvs7o'));